//TODO: refactor and/or use jquery?
function experienceForm() {
    var self = this;
    var experienceId = document.getElementById('Id');   
    var experienceTitle = document.getElementById('Title');   
    var experiences = document.getElementById('experiences');
    var experiencesHeading = document.getElementById('experiencesHeading');
    var tags = document.getElementById('Tags');
    var primaryAddressCityPicker = document.getElementById('primaryAddressCityPicker');
    var primaryAddressCity = document.getElementById('PrimaryAddress_City');
    var primaryAddressStateCode = document.getElementById('PrimaryAddress_StateCode');
    var primaryAddressStateName = document.getElementById('PrimaryAddress_StateName');
    var primaryAddressCountryCode = document.getElementById('PrimaryAddress_CountryCode');
        


    var searchtimeout = null;

    if (tags) {
        var tagsChoices = new choicesAutoComplete(tags);       
    }

    //for (var i = 0; i < choices.length; i++) {
    var primaryAddressCityPickerChoices = new choicesAutoComplete(primaryAddressCityPicker)
    primaryAddressCityPicker.addEventListener('change', function (evt) {
        var selected = primaryAddressCityPickerChoices.choices.getValue().customProperties;
        console.log(selected);
        primaryAddressCity.value = selected.city;
        primaryAddressStateCode.value = selected.stateCode;
        primaryAddressStateName.value = selected.stateName;
        primaryAddressCountryCode.value = selected.countryCode;

        //TODO: You are here.  finish this, but probably need to switch to angular/vue/etc. now...

    });
    //}
    

    if (experienceTitle) {
        customAutoComplete(experienceTitle, '/experienceproviders?skip=0&take=4&search=', function (res) {
            //TODO: polyfill for classList in IE9, 8?
            experiencesHeading.classList.remove('has-matches');
            experiences.innerHTML = "";
            if (!res) return;

            var matches = res.data.results || res.data;
           
            if (matches && matches.length) {
                
                for (var i = 0; i < matches.length; i++) {                    
                    var match = matches[i];
                    if (match.id.toString() === experienceId.value) continue;


                    experiencesHeading.classList.add('has-matches');
                    var link = document.createElement('a');
                    link.classList.add('pointer');
                    link.innerText = match.title; 
                    link.href = '/experiences/claim/' + match.id;
                    experiences.appendChild(link);
                }
            }
        });
    }

    //TODO: disable button if exact match.
}